import { render, staticRenderFns } from "./BroadcastsList.vue?vue&type=template&id=2fca4de1&scoped=true&"
import script from "./BroadcastsList.vue?vue&type=script&lang=js&"
export * from "./BroadcastsList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastsList.vue?vue&type=style&index=0&id=2fca4de1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fca4de1",
  null
  
)

export default component.exports